import { Box, SvgIcon, Flex } from '@volue/wave-react';
import React from 'react';

import type { Currents } from '@/features/execute-calculation-set/overmind/calculation/derived-state/shortCircuitSummary/mediumVoltage/MvShortCircuitSummaryEvaluatedResults';
import type { ElectricCurrentType } from '@/features/execute-calculation-set/overmind/calculation/domain/ElectricCurrent';
import type { Printable } from '@/features/execute-calculation-set/overmind/calculation/domain/Printable';
import type { EvaluatedResult } from '@/features/execute-calculation-set/overmind/calculation/evaluation/EvaluatedResult';

import { EvaluatedValue } from '../LoadFlowSummaryCalculationResults/EvaluatedCalculationResult';

type CurrentResultsProps = {
  summary: Currents;
  label: string;
};

export function CurrentResults(props: CurrentResultsProps) {
  const summary = props.summary;
  const anyResultAvailable =
    props.summary.phase1Max.type === 'CALCULATION_RESULT_AVAILABLE' ||
    props.summary.phase1Min.type === 'CALCULATION_RESULT_AVAILABLE' ||
    props.summary.phase2Min.type === 'CALCULATION_RESULT_AVAILABLE' ||
    props.summary.phase3Max.type === 'CALCULATION_RESULT_AVAILABLE';

  if (!anyResultAvailable) {
    return null;
  }
  return (
    <>
      <Box>
        <SvgIcon iconName="home" className="mRm" />
        {props.label}
      </Box>
      <Flex flow={'column'} className="w100 pLxl" gap={'spacingXs'}>
        {summary.phase1Min.type === 'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={summary.phase1Min.result}
            label={'Phase1Min'}
          />
        )}
        {summary.phase1Max.type === 'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={summary.phase1Max.result}
            label={'Phase1Max'}
          />
        )}
        {summary.phase2Min.type === 'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={summary.phase2Min.result}
            label={'Phase2Min'}
          />
        )}
        {summary.phase3Max.type === 'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={summary.phase3Max.result}
            label={'Phase3Max'}
          />
        )}
      </Flex>
    </>
  );
}

const EvaluatedResultsRange = <T extends Printable>(props: {
  range: { min: EvaluatedResult<T>; max: EvaluatedResult<T> };
  label: string;
}) => {
  return (
    <Flex main={'space-between'}>
      <span>
        {props.label}
        {':'}
      </span>
      <Box>
        <EvaluatedValue
          value={props.range.min.value.toString()}
          status={props.range.min.status}
        />
        <Box className="dIB mHxs">{'-'}</Box>
        <EvaluatedValue
          value={props.range.max.value.toString()}
          status={props.range.max.status}
        />
      </Box>
    </Flex>
  );
};
